const optionsData= [
    {
        'index': 0,
        'project_code': 'kumhotire25',
        'manager': 'QESG',
        'client': '금호타이어(주)',
        'client_id': 3227,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-05-20 00:00:00',
        'no_rating': false,
        'project_company_num': 73
    },
    {
        'index': 1,
        'project_code': 'kolon25',
        'manager': 'QESG',
        'client': '코오롱인더스트리(주)',
        'client_id': 6686,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-05-19 00:00:00',
        'no_rating': false,
        'project_company_num': 60
    },
    {
        'index': 2,
        'project_code': 'hoil25',
        'manager': 'QESG',
        'client': 'CLIENT_현대오일뱅크',
        'client_id': 6803,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-05-15 10:27:23',
        'no_rating': false,
        'project_company_num': 7
    },
    {
        'index': 3,
        'project_code': 'locknlock25',
        'manager': 'QESG',
        'client': 'CLIENT_락앤락',
        'client_id': 7002,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-05-12 00:00:00',
        'no_rating': false,
        'project_company_num': 42
    },
    {
        'index': 4,
        'project_code': 'shinhanb1',
        'manager': 'Shinhan',
        'client': '신한은행',
        'client_id': 6467,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-05-12 00:00:00',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 5,
        'project_code': 'esgin251h',
        'manager': 'QESG',
        'client': 'ESG인',
        'client_id': 6483,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-04-23 10:09:35',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 6,
        'project_code': 'dsscm25',
        'manager': 'QESG',
        'client': '(주)동성케미컬',
        'client_id': 7291,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-04-01 00:00:00',
        'no_rating': false,
        'project_company_num': 14
    },
    {
        'index': 7,
        'project_code': 'free251h',
        'manager': 'QESG',
        'client': 'QESG_Dashboard',
        'client_id': 1,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-03-31 13:31:42',
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 8,
        'project_code': '25TEST',
        'manager': 'QESG',
        'client': '(주)퀀티파이드이에스지',
        'client_id': null,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-03-30 21:49:01',
        'no_rating': false,
        'project_company_num': 11
    },
    {
        'index': 9,
        'project_code': 'qesg_basic',
        'manager': 'QESG',
        'client': '(주)퀀티파이드이에스지',
        'client_id': 1,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-03-28 18:14:53',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 10,
        'project_code': 'dsc25',
        'manager': 'QESG',
        'client': '(주)동성케미컬',
        'client_id': 7291,
        'period': '2025_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-03-28 00:00:00',
        'no_rating': false,
        'project_company_num': 43
    },
    {
        'index': 11,
        'project_code': 'esgin25',
        'manager': 'QESG',
        'client': 'ESG인',
        'client_id': 6483,
        'period': '2024_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-02-24 14:44:21',
        'no_rating': false,
        'project_company_num': 5
    },
    {
        'index': 12,
        'project_code': 'hldi25',
        'manager': 'QESG',
        'client': '에이치엘디앤아이한라(주)',
        'client_id': 7797,
        'period': '2024_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-04-10 00:00:00',
        'no_rating': false,
        'project_company_num': 9
    },
    {
        'index': 13,
        'project_code': 'qesg_basic242h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2024_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-01-03 00:00:00',
        'no_rating': false,
        'project_company_num': 4
    },
    {
        'index': 14,
        'project_code': 'coway242h',
        'manager': 'QESG',
        'client': '코웨이(주)',
        'client_id': 29,
        'period': '2024_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-11-20 13:12:59',
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 15,
        'project_code': 'buesg24',
        'manager': 'QESG',
        'client': '(주)퀀티파이드이에스지',
        'client_id': 1,
        'period': '2024_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-11-20 11:59:25',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 16,
        'project_code': 'qesg_basic_test',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2024_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-11-20 09:31:21',
        'no_rating': false,
        'project_company_num': 16
    },
    {
        'index': 17,
        'project_code': 'dgb24_con',
        'manager': 'QESG',
        'client': '(주)대구은행',
        'client_id': 4156,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-11-08 15:49:42',
        'no_rating': false,
        'project_company_num': 5
    },
    {
        'index': 18,
        'project_code': 'qesg_basic(on site)',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-11-05 16:35:50',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 19,
        'project_code': 'kbiz241h',
        'manager': 'QESG',
        'client': '중소기업중앙회',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-09-04 00:00:00',
        'no_rating': false,
        'project_company_num': 24
    },
    {
        'index': 20,
        'project_code': 'bm1100',
        'manager': 'NICE',
        'client': 'HL클레무브',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-07-30 00:00:00',
        'no_rating': false,
        'project_company_num': 28
    },
    {
        'index': 21,
        'project_code': 'dbhitek24',
        'manager': 'QESG',
        'client': 'DB하이텍',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-07-02 10:19:11',
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 22,
        'project_code': 'lxsm24',
        'manager': 'QESG',
        'client': 'CLIENT_LX세미콘',
        'client_id': 6470,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-05-22 15:07:00',
        'no_rating': false,
        'project_company_num': 20
    },
    {
        'index': 23,
        'project_code': 'hanaesg24',
        'manager': 'QESG',
        'client': '하나은행',
        'client_id': 7526,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-05-22 15:07:00',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 24,
        'project_code': 'dgb24',
        'manager': 'QESG',
        'client': '(주)대구은행',
        'client_id': 4156,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-05-22 15:07:00',
        'no_rating': false,
        'project_company_num': 21
    },
    {
        'index': 25,
        'project_code': 'kbin2324',
        'manager': 'QESG',
        'client': 'CLIENT_KB인베스트먼트',
        'client_id': 6466,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2025-04-19 00:00:00',
        'no_rating': false,
        'project_company_num': 29
    },
    {
        'index': 26,
        'project_code': 'hoil24',
        'manager': 'QESG',
        'client': 'CLIENT_현대오일뱅크',
        'client_id': 6803,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-04-19 09:55:26',
        'no_rating': false,
        'project_company_num': 8
    },
    {
        'index': 27,
        'project_code': 'locknlock24',
        'manager': 'QESG',
        'client': 'CLIENT_락앤락',
        'client_id': 7002,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-04-19 09:55:26',
        'no_rating': false,
        'project_company_num': 33
    },
    {
        'index': 28,
        'project_code': 'standard',
        'manager': 'NICE',
        'client': 'NICE',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 29,
        'project_code': 'bm1100_2',
        'manager': 'NICE',
        'client': '현대엔지니어링',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-10-01 00:00:00',
        'no_rating': false,
        'project_company_num': 184
    },
    {
        'index': 30,
        'project_code': 'hec1100',
        'manager': 'NICE',
        'client': '현대엔지니어링',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-10-01 00:00:00',
        'no_rating': false,
        'project_company_num': 33
    },
    {
        'index': 31,
        'project_code': 'kumhotire24',
        'manager': 'QESG',
        'client': '금호타이어(주)',
        'client_id': 3227,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-03-22 12:31:51',
        'no_rating': false,
        'project_company_num': 111
    },
    {
        'index': 32,
        'project_code': 'test241h',
        'manager': 'QESG',
        'client': '(주)퀀티파이드이에스지',
        'client_id': 1,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-03-22 12:31:51',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 33,
        'project_code': 'premium241h',
        'manager': 'QESG',
        'client': '(주)퀀티파이드이에스지',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-02-20 12:03:43',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 34,
        'project_code': 'BGF2024',
        'manager': 'QESG',
        'client': 'BGF리테일',
        'client_id': 7152,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-02-20 12:03:43',
        'no_rating': false,
        'project_company_num': 26
    },
    {
        'index': 35,
        'project_code': 'dsc24',
        'manager': 'QESG',
        'client': '(주)동성케미컬',
        'client_id': 7291,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-02-20 12:03:43',
        'no_rating': false,
        'project_company_num': 110
    },
    {
        'index': 36,
        'project_code': 'qesg_basic241h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-02-20 00:00:00',
        'no_rating': false,
        'project_company_num': 49
    },
    {
        'index': 37,
        'project_code': 'DSCO24',
        'manager': 'QESG',
        'client': '동성케미컬',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-15 16:31:24',
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 38,
        'project_code': 'shinhanb1241h',
        'manager': 'Shinhan',
        'client': '신한은행',
        'client_id': 6467,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-15 00:00:00',
        'no_rating': false,
        'project_company_num': 57
    },
    {
        'index': 39,
        'project_code': 'HGI24',
        'manager': 'QESG',
        'client': 'HGI',
        'client_id': 7269,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-15 16:31:24',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 40,
        'project_code': 'nfree241h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-15 16:31:24',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 41,
        'project_code': 'free241h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-15 16:31:24',
        'no_rating': false,
        'project_company_num': 26
    },
    {
        'index': 42,
        'project_code': 'kclsa',
        'manager': 'QESG',
        'client': 'KCL',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': true,
        'is_completed': null,
        'target_end_date': '2024-01-15 16:31:24',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 43,
        'project_code': 'bccei',
        'manager': 'QESG',
        'client': '부산창조경제혁신센터',
        'client_id': 7268,
        'period': '2024_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-09 11:08:47',
        'no_rating': false,
        'project_company_num': 8
    },
    {
        'index': 44,
        'project_code': 'HGI24232h',
        'manager': 'QESG',
        'client': 'HGI',
        'client_id': 7269,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2024-01-09 11:08:47',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 45,
        'project_code': 'kmip23',
        'manager': 'QESG',
        'client': '한국중부발전(주)',
        'client_id': 7154,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-27 18:04:00',
        'no_rating': false,
        'project_company_num': 35
    },
    {
        'index': 46,
        'project_code': 'bgf2023',
        'manager': 'QESG',
        'client': 'BGF리테일',
        'client_id': 7152,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '0000-00-00 00:00:00',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 47,
        'project_code': 'kbin2324232h',
        'manager': 'QESG',
        'client': 'CLIENT_KB인베스트먼트',
        'client_id': 6466,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-16 18:00:03',
        'no_rating': false,
        'project_company_num': 23
    },
    {
        'index': 48,
        'project_code': 'softbank23',
        'manager': 'QESG',
        'client': '스프트뱅크',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-14 12:08:15',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 49,
        'project_code': 'shinhanb1232h',
        'manager': 'QESG',
        'client': '신한은행',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-14 12:08:15',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 50,
        'project_code': 'shinhanesg',
        'manager': 'QESG',
        'client': '신한은행',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-14 12:08:15',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 51,
        'project_code': 'qesg_basic232h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-14 12:08:15',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 52,
        'project_code': 'notfree232h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-09 18:00:07',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 53,
        'project_code': 'nfree232h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-09 18:00:07',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 54,
        'project_code': 'free232h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-08 14:28:41',
        'no_rating': false,
        'project_company_num': 9
    },
    {
        'index': 55,
        'project_code': 'qesg_2023',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '0000_QESG',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-12-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 56,
        'project_code': 'dgbc23',
        'manager': 'QESG',
        'client': 'DGB',
        'client_id': 4156,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-12-30 18:00:00',
        'no_rating': false,
        'project_company_num': 5
    },
    {
        'index': 57,
        'project_code': 'ktop2023',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 30
    },
    {
        'index': 58,
        'project_code': 'KVIC23',
        'manager': 'QESG',
        'client': '한국벤처투자',
        'client_id': 7082,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 18
    },
    {
        'index': 59,
        'project_code': 'coway23dd',
        'manager': 'QESG',
        'client': '코웨이',
        'client_id': 29,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 9
    },
    {
        'index': 60,
        'project_code': 'coway23sa',
        'manager': 'QESG',
        'client': '코웨이',
        'client_id': 29,
        'period': '2023_1H',
        'self_assessment': true,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 61
    },
    {
        'index': 61,
        'project_code': 'hlk2100',
        'manager': 'NICE',
        'client': 'HL클레무브',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 16
    },
    {
        'index': 62,
        'project_code': 'mcesg23',
        'manager': 'QESG',
        'client': '중기중앙회',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 15
    },
    {
        'index': 63,
        'project_code': 'locknlock23',
        'manager': 'QESG',
        'client': '락앤락',
        'client_id': 7002,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 38
    },
    {
        'index': 64,
        'project_code': 'hl2100',
        'manager': 'NICE',
        'client': '만도',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 21
    },
    {
        'index': 65,
        'project_code': 'dgbc023',
        'manager': 'QESG',
        'client': 'DGB',
        'client_id': 4156,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 66,
        'project_code': 'lxsm23',
        'manager': 'QESG',
        'client': 'LX세미콘',
        'client_id': 6470,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-07-19 18:00:00',
        'no_rating': false,
        'project_company_num': 24
    },
    {
        'index': 67,
        'project_code': 'lt2100',
        'manager': 'NICE',
        'client': '롯데칠성',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 18
    },
    {
        'index': 68,
        'project_code': 'softbank23231h',
        'manager': 'QESG',
        'client': '소프트뱅크벤처스',
        'client_id': 6876,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 69,
        'project_code': 'shinhanesg231h',
        'manager': 'QESG',
        'client': '신한은행',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 70,
        'project_code': 'chemtopia23',
        'manager': 'Chemptopia',
        'client': '켐토피아',
        'client_id': 6893,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 71,
        'project_code': 'hoil23',
        'manager': 'QESG',
        'client': '현대오일뱅크',
        'client_id': 6803,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 72,
        'project_code': 'hec1100_231H',
        'manager': 'NICE',
        'client': '현대엔지니어링',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 178
    },
    {
        'index': 73,
        'project_code': 'kbin2023',
        'manager': 'QESG',
        'client': 'KB인베스트먼트',
        'client_id': 6466,
        'period': '2023_1H',
        'self_assessment': true,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 74,
        'project_code': 'poscocapital23',
        'manager': 'POSCOCAPITAL',
        'client': '포스코기술투자',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': true,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 75,
        'project_code': 'shinhanb1231h',
        'manager': 'Shinhan',
        'client': '신한은행',
        'client_id': 6467,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 26
    },
    {
        'index': 76,
        'project_code': 'esgcredit23',
        'manager': 'QESG',
        'client': '한국ESG크레딧',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 77,
        'project_code': 'buesg23',
        'manager': 'QESG',
        'client': 'ESG부울경산업분원',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-11-30 18:00:00',
        'no_rating': false,
        'project_company_num': 13
    },
    {
        'index': 78,
        'project_code': 'esgin23',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 6483,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 5
    },
    {
        'index': 79,
        'project_code': 'standard_231H',
        'manager': 'NICE',
        'client': 'NICE',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 80,
        'project_code': 'qesg_basic231h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 66
    },
    {
        'index': 81,
        'project_code': 'companya23',
        'manager': 'QESG',
        'client': 'Company A',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-27 18:00:00',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 82,
        'project_code': 're_231h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 9
    },
    {
        'index': 83,
        'project_code': 'kumhotire23',
        'manager': 'QESG',
        'client': '금호타이어',
        'client_id': 3227,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-07-31 18:00:00',
        'no_rating': false,
        'project_company_num': 171
    },
    {
        'index': 84,
        'project_code': 'akh23',
        'manager': 'QESG',
        'client': '개인컨설턴트',
        'client_id': 6605,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 85,
        'project_code': 'kosmes23 ',
        'manager': 'QESG',
        'client': '컨설팅산업협회',
        'client_id': 6604,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 86,
        'project_code': 'free231h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2023_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 99
    },
    {
        'index': 87,
        'project_code': 'mando1',
        'manager': 'NICE',
        'client': '만도',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 8
    },
    {
        'index': 88,
        'project_code': 'esgin23222h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 6483,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 89,
        'project_code': 'kbin2022',
        'manager': 'QESG',
        'client': 'KB인베스트먼트',
        'client_id': 6466,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-01 18:00:00',
        'no_rating': false,
        'project_company_num': 7
    },
    {
        'index': 90,
        'project_code': 'shinhanb221h',
        'manager': 'Shinhan',
        'client': '신한은행',
        'client_id': 6467,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-10-10 18:00:00',
        'no_rating': true,
        'project_company_num': 20
    },
    {
        'index': 91,
        'project_code': 'companya22',
        'manager': 'QESG',
        'client': 'Company A',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-01 18:00:00',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 92,
        'project_code': 'kwater22',
        'manager': 'QESG',
        'client': '한국수자원공사',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-01 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 93,
        'project_code': 'standard222h',
        'manager': 'NICE',
        'client': 'NICE',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-01 18:00:00',
        'no_rating': false,
        'project_company_num': 23
    },
    {
        'index': 94,
        'project_code': 'esg302',
        'manager': 'NICE',
        'client': 'NICE',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-01 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 95,
        'project_code': 'qesg_basic222h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2023-04-01 18:00:00',
        'no_rating': false,
        'project_company_num': 32
    },
    {
        'index': 96,
        'project_code': 'posco22capital',
        'manager': 'POSCOCAPITAL',
        'client': '포스코기술투자',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': true,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 4
    },
    {
        'index': 97,
        'project_code': 're_222h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 98,
        'project_code': 'kiat22c',
        'manager': 'QESG',
        'client': 'KIAT 규제자유특구',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-11-18 23:59:59',
        'no_rating': false,
        'project_company_num': 144
    },
    {
        'index': 99,
        'project_code': 'dgbcon22',
        'manager': 'QESG',
        'client': 'DGB금융그룹',
        'client_id': 4156,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-12-31 23:59:59',
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 100,
        'project_code': 'kbin20221h',
        'manager': 'QESG',
        'client': 'KB인베스트먼트',
        'client_id': 6466,
        'period': '2022_1H',
        'self_assessment': true,
        'is_completed': null,
        'target_end_date': '2022-12-31 23:59:59',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 101,
        'project_code': 'free222h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 6484,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 102,
        'project_code': 'mando2',
        'manager': 'NICE',
        'client': '만도',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-09-30 23:59:59',
        'no_rating': false,
        'project_company_num': 19
    },
    {
        'index': 103,
        'project_code': 'mando221h',
        'manager': 'NICE',
        'client': '만도',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-09-30 23:59:59',
        'no_rating': false,
        'project_company_num': 32
    },
    {
        'index': 104,
        'project_code': 'esg30221H',
        'manager': 'NICE',
        'client': 'NICE',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-09-30 23:59:59',
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 105,
        'project_code': 'coway2022',
        'manager': 'QESG',
        'client': '코웨이',
        'client_id': 29,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-09-30 23:59:59',
        'no_rating': false,
        'project_company_num': 12
    },
    {
        'index': 106,
        'project_code': 'hdec2',
        'manager': 'NICE',
        'client': '현대건설',
        'client_id': 6469,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-08-23 23:59:59',
        'no_rating': false,
        'project_company_num': 46
    },
    {
        'index': 107,
        'project_code': 'hdec1',
        'manager': 'NICE',
        'client': '현대건설',
        'client_id': 6469,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-08-24 23:59:59',
        'no_rating': false,
        'project_company_num': 432
    },
    {
        'index': 108,
        'project_code': 'dgb2022',
        'manager': 'QESG',
        'client': 'DGB금융그룹',
        'client_id': 5206,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-09-30 23:59:59',
        'no_rating': false,
        'project_company_num': 17
    },
    {
        'index': 109,
        'project_code': 'hyundai22',
        'manager': 'NICE',
        'client': '현대자동차',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-08-12 18:00:00',
        'no_rating': false,
        'project_company_num': 405
    },
    {
        'index': 110,
        'project_code': 're_221h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 38
    },
    {
        'index': 111,
        'project_code': 'lxsm22',
        'manager': 'QESG',
        'client': 'LX세미콘',
        'client_id': 6470,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-07-08 18:00:00',
        'no_rating': false,
        'project_company_num': 21
    },
    {
        'index': 112,
        'project_code': 'lottemro',
        'manager': 'NICE',
        'client': '롯데칠성음료 mro ',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-06-30 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 113,
        'project_code': 'kosmes22',
        'manager': 'QESG',
        'client': '한국컨설팅협회',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-06-30 18:00:00',
        'no_rating': false,
        'project_company_num': 42
    },
    {
        'index': 114,
        'project_code': 'hsteel22',
        'manager': 'QESG',
        'client': '현대제철',
        'client_id': 353,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-08-05 18:00:00',
        'no_rating': true,
        'project_company_num': 411
    },
    {
        'index': 115,
        'project_code': 'iwest1',
        'manager': 'NICE',
        'client': '서부발전',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-11-11 18:00:00',
        'no_rating': false,
        'project_company_num': 21
    },
    {
        'index': 116,
        'project_code': 'free221h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 58
    },
    {
        'index': 117,
        'project_code': 'ktop221h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-09-13 18:00:00',
        'no_rating': false,
        'project_company_num': 31
    },
    {
        'index': 118,
        'project_code': 'coway22',
        'manager': 'QESG',
        'client': '코웨이',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-04-29 18:00:00',
        'no_rating': false,
        'project_company_num': 40
    },
    {
        'index': 119,
        'project_code': 'pulmuone1',
        'manager': 'QESG',
        'client': '풀무원',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-05-13 18:00:00',
        'no_rating': false,
        'project_company_num': 25
    },
    {
        'index': 120,
        'project_code': 'hyundai22saq',
        'manager': 'NICE',
        'client': '현대자동차',
        'client_id': null,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-06-03 18:00:00',
        'no_rating': false,
        'project_company_num': 1839
    },
    {
        'index': 121,
        'project_code': 'standard221H',
        'manager': 'NICE',
        'client': '일반',
        'client_id': 1,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-10-10 18:00:00',
        'no_rating': false,
        'project_company_num': 17
    },
    {
        'index': 122,
        'project_code': 'esg30',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-10-10 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 123,
        'project_code': 'venesg33',
        'manager': 'NICE',
        'client': '한국벤처기업협회_심화',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-10-10 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 124,
        'project_code': 'ven2esg',
        'manager': 'NICE',
        'client': '한국벤처기업협회_표준',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-10-10 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 125,
        'project_code': 'qesg_basic221h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': 1,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-10-10 18:00:00',
        'no_rating': false,
        'project_company_num': 35
    },
    {
        'index': 126,
        'project_code': 'hec1',
        'manager': 'NICE',
        'client': '현대엔지니어링',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-06-11 18:00:00',
        'no_rating': false,
        'project_company_num': 235
    },
    {
        'index': 127,
        'project_code': 'shinhanb1222h',
        'manager': 'Shinhan',
        'client': '신한은행',
        'client_id': 6467,
        'period': '2022_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-03-31 18:00:00',
        'no_rating': false,
        'project_company_num': 19
    },
    {
        'index': 128,
        'project_code': 'lottecs2',
        'manager': 'NICE',
        'client': '롯데칠성음료',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-06-10 18:00:00',
        'no_rating': false,
        'project_company_num': 17
    },
    {
        'index': 129,
        'project_code': '221htest',
        'manager': 'QESG',
        'client': '221테스트',
        'client_id': null,
        'period': '2022_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-06-01 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 130,
        'project_code': '전문ESG',
        'manager': 'NICE',
        'client': '전문건설공제조합 ',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 131,
        'project_code': 'mando2212h',
        'manager': 'NICE',
        'client': '만도',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-06-01 18:00:00',
        'no_rating': false,
        'project_company_num': 35
    },
    {
        'index': 132,
        'project_code': 'shbp212h',
        'manager': 'Shinhan',
        'client': '신한은행',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2022-02-28 18:00:00',
        'no_rating': true,
        'project_company_num': 6
    },
    {
        'index': 133,
        'project_code': 'esg30212H',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-03-31 18:00:00',
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 134,
        'project_code': 'venesg33212H',
        'manager': 'NICE',
        'client': '한국벤처기업협회_심화',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-03-31 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 135,
        'project_code': 'ven2esg212H',
        'manager': 'NICE',
        'client': '한국벤처기업협회_표준',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-03-31 18:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 136,
        'project_code': 'esg30211H',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 137,
        'project_code': 'esgfree',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 138,
        'project_code': 'jbtp23',
        'manager': 'NICE',
        'client': '전북테크노파크',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 139,
        'project_code': 'esg013',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 140,
        'project_code': 'jbtp01',
        'manager': 'NICE',
        'client': '전북테크노파크',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 13
    },
    {
        'index': 141,
        'project_code': 'ON1000000386',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 142,
        'project_code': 'hoilesg',
        'manager': 'NICE',
        'client': '현대오일뱅크',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 143,
        'project_code': 'ESG_investment',
        'manager': 'QESG',
        'client': '일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 74
    },
    {
        'index': 144,
        'project_code': 'hkmcesg',
        'manager': 'NICE',
        'client': '현대자동차',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 61
    },
    {
        'index': 145,
        'project_code': 'free212h',
        'manager': 'QESG',
        'client': 'QESG',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 146,
        'project_code': 'esg30212H_2',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 147,
        'project_code': 'wbizesg2',
        'manager': 'NICE',
        'client': '한국여성경제인협회_심화',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 148,
        'project_code': 'wbizesg1',
        'manager': 'NICE',
        'client': '한국여성경제인협회_표준',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 149,
        'project_code': 'debcesg2',
        'manager': 'NICE',
        'client': '장애인기업종합지원센터_심화',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 150,
        'project_code': 'debcesg1',
        'manager': 'NICE',
        'client': '장애인기업종합지원센터_표준',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 151,
        'project_code': 'esg100',
        'manager': 'NICE',
        'client': '심화',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 152,
        'project_code': 'gtckesg2',
        'manager': 'NICE',
        'client': '녹색기술센터_심화',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-01-07 00:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 153,
        'project_code': 'gtckesg1',
        'manager': 'NICE',
        'client': '녹색기술센터_표준',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-01-07 00:00:00',
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 154,
        'project_code': 'iwestesg',
        'manager': 'NICE',
        'client': '한국서부발전',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': '2022-01-07 00:00:00',
        'no_rating': false,
        'project_company_num': 29
    },
    {
        'index': 155,
        'project_code': 'hanaesg2',
        'manager': 'NICE',
        'client': '하나은행',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 1
    },
    {
        'index': 156,
        'project_code': 'kiat21a',
        'manager': 'QESG',
        'client': 'KIAT 규제자유특구_과제',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-12-17 18:00:00',
        'no_rating': false,
        'project_company_num': 8
    },
    {
        'index': 157,
        'project_code': 'ksa21semes',
        'manager': 'KSA',
        'client': '한국표준협회',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-11-19 18:00:00',
        'no_rating': false,
        'project_company_num': 5
    },
    {
        'index': 158,
        'project_code': 'kiat21c',
        'manager': 'QESG',
        'client': 'KIAT 규제자유특구_기업',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-11-30 18:00:00',
        'no_rating': false,
        'project_company_num': 27
    },
    {
        'index': 159,
        'project_code': 'ibkesg2',
        'manager': 'NICE',
        'client': '기업은행',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 5
    },
    {
        'index': 160,
        'project_code': 'cbtpesg',
        'manager': 'NICE',
        'client': '충북테크노파크',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-12-06 18:00:00',
        'no_rating': false,
        'project_company_num': 9
    },
    {
        'index': 161,
        'project_code': 'divaesg_211H',
        'manager': 'NICE',
        'client': '대덕이노폴리스벤처협회',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-11-19 18:00:00',
        'no_rating': false,
        'project_company_num': 22
    },
    {
        'index': 162,
        'project_code': 'standard212H',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 14
    },
    {
        'index': 163,
        'project_code': 'ltchesg',
        'manager': 'NICE',
        'client': '롯데케미칼',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-11-05 18:00:00',
        'no_rating': false,
        'project_company_num': 45
    },
    {
        'index': 164,
        'project_code': '-',
        'manager': 'NICE',
        'client': '신청오류',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 165,
        'project_code': 'mandoesg',
        'manager': 'NICE',
        'client': '만도',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-10-08 18:00:00',
        'no_rating': false,
        'project_company_num': 23
    },
    {
        'index': 166,
        'project_code': 'cjecesg',
        'manager': 'NICE',
        'client': 'CJ대한통운 건설부문',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 7
    },
    {
        'index': 167,
        'project_code': 'ven2esg211h',
        'manager': 'NICE',
        'client': '한국벤처기업협회_표준',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 3
    },
    {
        'index': 168,
        'project_code': 'jbinesg2',
        'manager': 'NICE',
        'client': '전북연구개발특구-심화',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 14
    },
    {
        'index': 169,
        'project_code': 'jbinesg1',
        'manager': 'NICE',
        'client': '전북연구개발특구-일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 12
    },
    {
        'index': 170,
        'project_code': 'jbbaesg',
        'manager': 'NICE',
        'client': '전북경제통상진흥원',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-09-30 18:00:00',
        'no_rating': false,
        'project_company_num': 8
    },
    {
        'index': 171,
        'project_code': 'ibkesg',
        'manager': 'NICE',
        'client': '기업은행',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 4
    },
    {
        'index': 172,
        'project_code': 'hanaesg',
        'manager': 'NICE',
        'client': '하나은행',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 2
    },
    {
        'index': 173,
        'project_code': 'SKIET',
        'manager': 'NICE',
        'client': 'SK아이이테크놀로지',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-06-11 00:00:00',
        'no_rating': false,
        'project_company_num': 53
    },
    {
        'index': 174,
        'project_code': 'SKChemical',
        'manager': 'NICE',
        'client': 'SK케미칼',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-06-11 00:00:00',
        'no_rating': false,
        'project_company_num': 32
    },
    {
        'index': 175,
        'project_code': 'standard211H',
        'manager': 'NICE',
        'client': '일반',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 20
    },
    {
        'index': 176,
        'project_code': 'test_1',
        'manager': 'QESG',
        'client': '퀀티파이드이에스지',
        'client_id': null,
        'period': '2021_2H',
        'self_assessment': false,
        'is_completed': null,
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': null
    },
    {
        'index': 177,
        'project_code': 'venesg',
        'manager': 'NICE',
        'client': '한국벤처기업협회',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-07-30 00:00:00',
        'no_rating': false,
        'project_company_num': 34
    },
    {
        'index': 178,
        'project_code': 'hkmc2esg',
        'manager': 'NICE',
        'client': '현대자동차',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-09-03 00:00:00',
        'no_rating': false,
        'project_company_num': 22
    },
    {
        'index': 179,
        'project_code': 'cjesg',
        'manager': 'NICE',
        'client': 'CJ올리브네크웍스',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-07-16 00:00:00',
        'no_rating': false,
        'project_company_num': 67
    },
    {
        'index': 180,
        'project_code': 'jbtp623',
        'manager': 'NICE',
        'client': '전북테크노파크',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-07-09 00:00:00',
        'no_rating': false,
        'project_company_num': 15
    },
    {
        'index': 181,
        'project_code': 'hwecesg',
        'manager': 'NICE',
        'client': '한화건설',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-08-31 00:00:00',
        'no_rating': false,
        'project_company_num': 16
    },
    {
        'index': 182,
        'project_code': '전문ESG211H',
        'manager': 'NICE',
        'client': '전문건설공제조합',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 9
    },
    {
        'index': 183,
        'project_code': 'gtck708',
        'manager': 'NICE',
        'client': '녹색기술센터',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-08-31 00:00:00',
        'no_rating': false,
        'project_company_num': 6
    },
    {
        'index': 184,
        'project_code': 'sktesg',
        'manager': 'NICE',
        'client': 'SK텔레콤',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-08-20 00:00:00',
        'no_rating': false,
        'project_company_num': 60
    },
    {
        'index': 185,
        'project_code': 'skinesg',
        'manager': 'NICE',
        'client': 'SK이노베이션',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': '2021-10-31 00:00:00',
        'no_rating': false,
        'project_company_num': 245
    },
    {
        'index': 186,
        'project_code': 'hdecesg',
        'manager': 'NICE',
        'client': '현대건설',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 249
    },
    {
        'index': 187,
        'project_code': 'gsc002',
        'manager': 'QESG',
        'client': 'GS칼텍스',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 187
    },
    {
        'index': 188,
        'project_code': 'gsc001',
        'manager': 'QESG',
        'client': 'GS칼텍스',
        'client_id': null,
        'period': '2021_1H',
        'self_assessment': false,
        'is_completed': 'completed',
        'target_end_date': null,
        'no_rating': false,
        'project_company_num': 135
    }
];

export {optionsData};
